import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient-care")({
  component: () => <Outlet />,
});
